<template>

  <div id="new" class="main layer2" style="height: calc(100% - 2.5rem); padding-top: 2.5rem; overflow: auto;">
    <top id="top-nav" :title="title" :detailType="datailType" style="margin-top: -2.5rem;"></top>
    <vod-list :show-title="false" :vodData="list"></vod-list>
    <loading ref="loading" scroll-div="new" :is-loading="isLoading" :is-no-more-data="isNoMoreData" @get-books="getVodCategory(currentPage + 1)"></loading>
  </div>
</template>

<script>
  import VodList from '@/components/share/vod-list.vue'
  import Loading from "../../../components/share/loading";
  import vodService from "../../../services/vodService";
  import BookTop from '@/components/layer2/book/book-top';

  export default {
    name: "VodCategory",
    data() {
      return {
        componentName: '',
        datailType: 'vod',
        title: '',
        list: [],
        isLoading: false,
        isNoMoreData: false,
        category: 1,
        currentPage: 1
      }
    },
    watch: {
      '$route': 'gettingData'
    },
    methods: {
      getVodCategory(target) {
        this.currentPage = target;
        if(target === 1) {
          this.list = []
        }
        this.isLoading = true;
        this.isNoMoreData = false;
        vodService.getLatest(this.category,target)
          .then(res => {
            this.isLoading = false;
            if (res.data.totalPage === 0) {
              this.isNoMoreData = true;
              this.list = []
            } else if (this.currentPage === 1) {
              this.list = res.data.list;
            } else if (this.currentPage > 1 && this.currentPage <= res.data.totalPage) {
              this.list.push(...res.data.list);
            }
            if (res.data.totalPage == 0 || this.currentPage >= res.data.totalPage) {
              this.isNoMoreData = true;
            }
            setTimeout(() => {
              this.$refs['loading'].scrollFunction();
            }, 0)
          })
      },
      gettingData(){
        this.category = this.$route.query.cid

      }
    },
    components: {
      'vod-list': VodList,
      loading: Loading,
      top: BookTop
    },
    mounted() {
      this.gettingData();
      switch(parseInt(this.category)){
        case 1:
          this.title = '每日推荐'
          break;
        case 2:
          this.title = '自拍探花'
          break;
        case 3:
          this.title = '精品热播'
          break;
        case 4:
          this.title = '国产传媒'
          break;
        case 5:
          this.title = '无码特区'
          break;
        case 6:
          this.title = '中文字幕'
          break;
        case 7:
          this.title = '人妻乱伦'
          break;
        case 8:
          this.title = '激情动漫'
          break;
        case 9:
          this.title = '日韩剧情'
          break;
        case 10:
          this.title = '欧美风情'
          break;
      }
      this.componentName = this.$route.name;
      if(this.$store.state.pageState[this.componentName] && this.$router.isBack) {
        Object.assign(this.$data, this.$store.state.pageState[this.$route.name].data);
        setTimeout(() => {
          let scrollDiv = document.getElementById('new');
          scrollDiv.scrollTop = this.$store.state.pageState[this.$route.name].top;
        }, 0);
      }
      else {
        this.getVodCategory(1);
      }
      this.$router.isBack = true;
    },
    beforeDestroy() {
      let scrollDiv = document.getElementById('new');
      let state = {};
      state[this.componentName] = {data: this.$data, top: scrollDiv.scrollTop}
      this.$store.commit('saveState', state);
    }


  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/layer2/vod/category.vue